import { AbstractZone } from './abstract-zone';

export class NavZone extends AbstractZone<NavZone> {
  static readonly KEEP_IN_MODE = 'keep_in';
  static readonly KEEP_OUT_MODE = 'keep_out';
  static readonly SPEED_MODE = 'speed';

  mode: string;
  description: string;
  priority: number;
  speed_mps: number;


  static isKeepOut(z?: Partial<NavZone> | any): boolean {
    return (z?.mode === NavZone.KEEP_OUT_MODE) || (z?.mode === 'keep_out');
  }

  static isSpeed(z?: Partial<NavZone> | any): boolean {
    return (z?.mode === NavZone.SPEED_MODE) || (z?.mode === 'speed');
  }

  /**
   * Precedence ordering:
   *  - lower priority number wins (comes first)
   *  - tie: lower speed wins (comes first)
   *  - tie: stable by id
   */
  static comparePrecedence(a: Partial<NavZone> | any, b: Partial<NavZone> | any): number {
    // Keep-out always wins
    const ak = NavZone.isKeepOut(a);
    const bk = NavZone.isKeepOut(b);
    if (ak !== bk) return ak ? -1 : 1;

    // Lower priority number wins
    const pa = a?.priority ?? 0;
    const pb = b?.priority ?? 0;
    if (pa !== pb) return pa - pb;

    // Tie-break: lower speed wins (only for speed zones)
    const sa = NavZone.isSpeed(a) ? (a?.speed_mps ?? Number.POSITIVE_INFINITY) : Number.POSITIVE_INFINITY;
    const sb = NavZone.isSpeed(b) ? (b?.speed_mps ?? Number.POSITIVE_INFINITY) : Number.POSITIVE_INFINITY;
    if (sa !== sb) return sa - sb;

    // Stable tie-break
    return (a?.id ?? 0) - (b?.id ?? 0);
  }

  deserialize(json: any): this {
    this.mode = json.mode;
    this.description = json.description;
    this.priority = json.priority;
    this.speed_mps = json.speed_mps;
    return super.deserialize(json);
  }

  serialize(): any {
    return Object.assign(super.serialize(), {
      mode: this.mode,
      description: this.description,
      priority: this.priority,
      speed_mps: this.speed_mps,
    });
  }
}
